import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import { UI_CONFIG } from "./constants";

interface EmptyStateProps {
  message: string;
  isError?: boolean;
  showBorder?: boolean;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  message,
  isError = false,
  showBorder = false,
}) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: theme.palette.customBackground.light,
        borderRadius: UI_CONFIG.borderRadius,
        ...(showBorder && {
          border: `2px dashed ${theme.palette.border.light}`,
        }),
      }}
    >
      <Typography variant="h6" color={isError ? "error" : "textSecondary"}>
        {message}
      </Typography>
    </Box>
  );
};
